"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFunctionAssertions = exports.FunctionExternalConnectionsAssigned = exports.FunctionExternalComponentsAssigned = exports.FunctionDependenciesSatisfied = exports.FunctionSignalAssignmentsValid = exports.FunctionRequiredSignalsAssigned = exports.RequiredFunctionsUsed = exports.ComponentFunctionRequirement = void 0;
const enums_1 = require("../enums");
const COMPONENT_FUNCTION_REQUIREMENT_ID = 'req_cadstromcfun000000000000000000000000';
exports.ComponentFunctionRequirement = {
    id: COMPONENT_FUNCTION_REQUIREMENT_ID,
    slug: 'cadstrom.function',
    slugPrefix: 'FUNCTION',
    name: 'Component Function',
    description: 'Asserts that every function a component’s package declares — an electrical role the part can perform (an I²C controller, a voltage regulator, a GPIO) — is correctly and completely implemented: mandatory functions are used, a used function assigns all of its required signals with valid assignments, its dependencies are satisfied, and its required external components and connections are present. Evaluated once per component function.',
};
exports.RequiredFunctionsUsed = {
    id: 'asrt_cfunreqused000000000000000000000000',
    slug: 'cadstrom.function.usage.required_functions_used',
    requirementDefinitionId: COMPONENT_FUNCTION_REQUIREMENT_ID,
    name: 'Required component functions must be used',
    description: 'A function the component’s package declares as mandatory must be assigned to an active role in the design. A required function left unused means a capability the part must provide is absent.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.FunctionRequiredSignalsAssigned = {
    id: 'asrt_cfunsigassigned00000000000000000000',
    slug: 'cadstrom.function.signals.required_signals_assigned',
    requirementDefinitionId: COMPONENT_FUNCTION_REQUIREMENT_ID,
    name: 'Every required function signal must be assigned',
    description: 'Every required (non-optional) signal of a used function — including the full set of co-required signals for multi-signal functions — must be assigned to a component signal. A function with an unassigned required signal is incompletely implemented.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.FunctionSignalAssignmentsValid = {
    id: 'asrt_cfunassignvalid00000000000000000000',
    slug: 'cadstrom.function.signals.assignments_valid',
    requirementDefinitionId: COMPONENT_FUNCTION_REQUIREMENT_ID,
    name: 'Function signal assignments must be valid',
    description: 'Every assigned component signal must be a legal target for its function signal; a signal that does not permit multiple assignments must have exactly one, and no signal may exceed its maximum number of assignments.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.FunctionDependenciesSatisfied = {
    id: 'asrt_cfundepssatisfied000000000000000000',
    slug: 'cadstrom.function.dependencies.satisfied',
    requirementDefinitionId: COMPONENT_FUNCTION_REQUIREMENT_ID,
    name: 'Function dependencies must be satisfied',
    description: 'The conditions for the function to be used must be met: any other functions it depends on must themselves be in the required used/unused state, and any device mode it requires must be in the necessary state.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.FunctionExternalComponentsAssigned = {
    id: 'asrt_cfunextcomponents000000000000000000',
    slug: 'cadstrom.function.external.components_assigned',
    requirementDefinitionId: COMPONENT_FUNCTION_REQUIREMENT_ID,
    name: 'Required external components must be present and correctly assigned',
    description: 'Every external component the function requires (declared via its conditions) — a bus counterpart, a required bias resistor — must be assigned to a valid component reachable from the function’s signals.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.FunctionExternalConnectionsAssigned = {
    id: 'asrt_cfunextconnections00000000000000000',
    slug: 'cadstrom.function.external.connections_assigned',
    requirementDefinitionId: COMPONENT_FUNCTION_REQUIREMENT_ID,
    name: 'Required external connections must be assigned',
    description: 'Every external connection the function’s required components declare must be assigned. An unassigned connection leaves a required external hookup absent.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.ComponentFunctionAssertions = [
    exports.RequiredFunctionsUsed,
    exports.FunctionRequiredSignalsAssigned,
    exports.FunctionSignalAssignmentsValid,
    exports.FunctionDependenciesSatisfied,
    exports.FunctionExternalComponentsAssigned,
    exports.FunctionExternalConnectionsAssigned,
];
//# sourceMappingURL=component-function.js.map